import { createFileRoute } from '@tanstack/react-router'

import { PagePlaceholder } from '@/components/shared'

export const Route = createFileRoute('/spravce/profil')({
  head: () => ({ meta: [{ title: 'Profil · Aplikace Bitez' }] }),
  component: SpravceProfil,
})

function SpravceProfil() {
  return (
    <PagePlaceholder
      title="Profil"
      note="Účet, notifikace a správa trend databáze — navrhneme příště."
    />
  )
}
